import colors from 'vuetify/es5/util/colors'
// import Vue from "vue/types/vue";
import Vue from 'vue'
import Vuetify from 'vuetify'

let icons = {
  iconfont: 'md'
}

let theme
if (process.env.NODE_ENV === 'production') {
  // Color scheme for production
  theme = {
    primary: colors.indigo.base,
    accent: colors.orange.base,
    error: colors.red.base,
    warn: colors.red.base,
    background: '#FFFFFF'
  }
} else {
  // Different colors for development
  theme = {
    dark: false,
    primary: colors.blue.base,
    accent: colors.amber.base,
    error: colors.red.base,
    warn: colors.red.base,
    background: '#FFFFFF'
  }
}

const options = {
  theme,
  icons
}

Vue.use(Vuetify, options)

export default new Vuetify(options)

/*
export default {
  theme,
  icons
} */
